// GENERATED FROM 'messages.json' (via yarn run messages:generate)
// !! DO NOT CHANGE MANUALLY !!

import { type ReactElement, type ReactNode } from "react";

import { FormattedMessage, defineMessages } from "react-intl";

export const WelcomeTitle = (props: { name: ReactNode }): ReactElement => (
    <FormattedMessage
        id="apps.home.components.welcomeTitle"
        description="Welcome title."
        defaultMessage="Welcome, {name}"
        values={props}
    />
);
WelcomeTitle.displayName = "WelcomeTitle";

export const HomeSubtitle = (): ReactElement => (
    <FormattedMessage
        id="apps.home.components.homeSubtitle"
        description="Home subtitle."
        defaultMessage="See how your Lenses are performing and earning"
    />
);
HomeSubtitle.displayName = "HomeSubtitle";

export const EngagementAndReach = (): ReactElement => (
    <FormattedMessage
        id="apps.home.components.engagementAndReach"
        description="Engagement and reach."
        defaultMessage="Engagement & Reach"
    />
);
EngagementAndReach.displayName = "EngagementAndReach";

export const EngagementAndReachSubtitle = (): ReactElement => (
    <FormattedMessage
        id="apps.home.components.engagementAndReachSubtitle"
        description="Engagement and reach subtitle."
        defaultMessage="How many Snapchatters interacted with your Lens. Non-subscribers may see a paywall and cannot send, snap, or play. These numbers do not affect your earnings."
    />
);
EngagementAndReachSubtitle.displayName = "EngagementAndReachSubtitle";

export const StatsTotalPlays = (): ReactElement => (
    <FormattedMessage
        id="apps.home.components.statsTotalPlays"
        description="Stats total plays."
        defaultMessage="Total Plays"
    />
);
StatsTotalPlays.displayName = "StatsTotalPlays";

export const StatsTotalPlaysTooltip = (): ReactElement => (
    <FormattedMessage
        id="apps.home.components.statsTotalPlaysTooltip"
        description="Stats total plays tooltip."
        defaultMessage="The total number of times your Lens(es) have been played."
    />
);
StatsTotalPlaysTooltip.displayName = "StatsTotalPlaysTooltip";

export const StatsTotalShares = (): ReactElement => (
    <FormattedMessage
        id="apps.home.components.statsTotalShares"
        description="Stats total shares."
        defaultMessage="Total Shares"
    />
);
StatsTotalShares.displayName = "StatsTotalShares";

export const StatsTotalSharesTooltip = (): ReactElement => (
    <FormattedMessage
        id="apps.home.components.statsTotalSharesTooltip"
        description="Stats total shares tooltip."
        defaultMessage="The total number of times your Lens(es) have been shared."
    />
);
StatsTotalSharesTooltip.displayName = "StatsTotalSharesTooltip";

export const StatsTotalPayouts = (): ReactElement => (
    <FormattedMessage
        id="apps.home.components.statsTotalPayouts"
        description="Stats total payouts."
        defaultMessage="Earnings"
    />
);
StatsTotalPayouts.displayName = "StatsTotalPayouts";

export const StatsTotalPayoutsTooltip = (): ReactElement => (
    <FormattedMessage
        id="apps.home.components.statsTotalPayoutsTooltip"
        description="Stats total payouts tooltip."
        defaultMessage="The total amount you have been paid for the selected time period."
    />
);
StatsTotalPayoutsTooltip.displayName = "StatsTotalPayoutsTooltip";

export const StatsLensPlusSubscriberActions = (): ReactElement => (
    <FormattedMessage
        id="apps.home.components.statsLensPlusSubscriberActions"
        description="Stats lens plus subscriber actions."
        defaultMessage="Lens+ Users"
    />
);
StatsLensPlusSubscriberActions.displayName = "StatsLensPlusSubscriberActions";

export const StatsLensPlusSubscriberActionsTooltip = (): ReactElement => (
    <FormattedMessage
        id="apps.home.components.statsLensPlusSubscriberActionsTooltip"
        description="Stats lens plus subscriber actions tooltip."
        defaultMessage="The number of Lens+ subscribers who sent, posted, or played your Lens. The more they interact with it, the more you earn."
    />
);
StatsLensPlusSubscriberActionsTooltip.displayName = "StatsLensPlusSubscriberActionsTooltip";

export const StatsLensPlusSubscriberActionsTooltipMeta = (): ReactElement => (
    <FormattedMessage
        id="apps.home.components.statsLensPlusSubscriberActionsTooltipMeta"
        description="Stats lens plus subscriber actions tooltip meta."
        defaultMessage="Used in payout formula · Data starting from April 1, 2026"
    />
);
StatsLensPlusSubscriberActionsTooltipMeta.displayName = "StatsLensPlusSubscriberActionsTooltipMeta";

export const StatsTotalReach = (): ReactElement => (
    <FormattedMessage
        id="apps.home.components.statsTotalReach"
        description="Stats total reach."
        defaultMessage="Total Reach"
    />
);
StatsTotalReach.displayName = "StatsTotalReach";

export const StatsTotalReachTooltip = (): ReactElement => (
    <FormattedMessage
        id="apps.home.components.statsTotalReachTooltip"
        description="Stats total reach tooltip."
        defaultMessage="The total number of users that have viewed or played with your Lens(es)."
    />
);
StatsTotalReachTooltip.displayName = "StatsTotalReachTooltip";

export const StatsVsPrevious = (props: { days: ReactNode }): ReactElement => (
    <FormattedMessage
        id="apps.home.components.statsVsPrevious"
        description="Stats vs previous."
        defaultMessage="vs. previous {days} days"
        values={props}
    />
);
StatsVsPrevious.displayName = "StatsVsPrevious";

export const TopLensesByReach = (): ReactElement => (
    <FormattedMessage
        id="apps.home.components.topLensesByReach"
        description="Top lenses by reach."
        defaultMessage="Top Lenses by Reach"
    />
);
TopLensesByReach.displayName = "TopLensesByReach";

export const TopLensesByReachSubtitle = (): ReactElement => (
    <FormattedMessage
        id="apps.home.components.topLensesByReachSubtitle"
        description="Top lenses by reach subtitle."
        defaultMessage="Your Lenses that reached the most Snapchatters."
    />
);
TopLensesByReachSubtitle.displayName = "TopLensesByReachSubtitle";

export const TopLensesByPayouts = (): ReactElement => (
    <FormattedMessage
        id="apps.home.components.topLensesByPayouts"
        description="Top lenses by payouts."
        defaultMessage="Top Lenses by Payouts"
    />
);
TopLensesByPayouts.displayName = "TopLensesByPayouts";

export const TopLensesByPayoutsSubtitle = (): ReactElement => (
    <FormattedMessage
        id="apps.home.components.topLensesByPayoutsSubtitle"
        description="Top lenses by payouts subtitle."
        defaultMessage="Your Lenses that received the most payouts."
    />
);
TopLensesByPayoutsSubtitle.displayName = "TopLensesByPayoutsSubtitle";

export const TableHeaderIcon = (): ReactElement => (
    <FormattedMessage
        id="apps.home.components.tableHeaderIcon"
        description="Table header icon."
        defaultMessage="Icon"
    />
);
TableHeaderIcon.displayName = "TableHeaderIcon";

export const TableHeaderName = (): ReactElement => (
    <FormattedMessage
        id="apps.home.components.tableHeaderName"
        description="Table header name."
        defaultMessage="Name"
    />
);
TableHeaderName.displayName = "TableHeaderName";

export const TableHeaderReach = (): ReactElement => (
    <FormattedMessage
        id="apps.home.components.tableHeaderReach"
        description="Table header reach."
        defaultMessage="Reach"
    />
);
TableHeaderReach.displayName = "TableHeaderReach";

export const TableHeaderPayout = (): ReactElement => (
    <FormattedMessage
        id="apps.home.components.tableHeaderPayout"
        description="Table header payout."
        defaultMessage="Payout"
    />
);
TableHeaderPayout.displayName = "TableHeaderPayout";

export const TableHeaderEvent = (): ReactElement => (
    <FormattedMessage
        id="apps.home.components.tableHeaderEvent"
        description="Table header event."
        defaultMessage="Event"
    />
);
TableHeaderEvent.displayName = "TableHeaderEvent";

export const TableHeaderTag = (): ReactElement => (
    <FormattedMessage id="apps.home.components.tableHeaderTag" description="Table header tag." defaultMessage="Tag" />
);
TableHeaderTag.displayName = "TableHeaderTag";

export const TableHeaderLocation = (): ReactElement => (
    <FormattedMessage
        id="apps.home.components.tableHeaderLocation"
        description="Table header location."
        defaultMessage="Location"
    />
);
TableHeaderLocation.displayName = "TableHeaderLocation";

export const TableHeaderExpirationDate = (): ReactElement => (
    <FormattedMessage
        id="apps.home.components.tableHeaderExpirationDate"
        description="Table header expiration date."
        defaultMessage="Expiration Date"
    />
);
TableHeaderExpirationDate.displayName = "TableHeaderExpirationDate";

export const TableHeaderDaysLeft = (): ReactElement => (
    <FormattedMessage
        id="apps.home.components.tableHeaderDaysLeft"
        description="Table header days left."
        defaultMessage="Days left"
    />
);
TableHeaderDaysLeft.displayName = "TableHeaderDaysLeft";

export const TrendingOnSpotlight = (): ReactElement => (
    <FormattedMessage
        id="apps.home.components.trendingOnSpotlight"
        description="Trending on spotlight."
        defaultMessage="Trending on Spotlight"
    />
);
TrendingOnSpotlight.displayName = "TrendingOnSpotlight";

export const TrendingTags = (): ReactElement => (
    <FormattedMessage
        id="apps.home.components.trendingTags"
        description="Trending tags."
        defaultMessage="Tags of the Month"
    />
);
TrendingTags.displayName = "TrendingTags";

export const MadeWithYourLenses = (): ReactElement => (
    <FormattedMessage
        id="apps.home.components.madeWithYourLenses"
        description="Made with your lenses."
        defaultMessage="Made with Your Lenses"
    />
);
MadeWithYourLenses.displayName = "MadeWithYourLenses";

export const MadeWithYourLensesSubtitle = (): ReactElement => (
    <FormattedMessage
        id="apps.home.components.madeWithYourLensesSubtitle"
        description="Made with your lenses subtitle."
        defaultMessage="Spotlight stories created using your Lenses. Data is typically updated daily."
    />
);
MadeWithYourLensesSubtitle.displayName = "MadeWithYourLensesSubtitle";

export const MadeWithYourLensesNoStories = (): ReactElement => (
    <FormattedMessage
        id="apps.home.components.madeWithYourLensesNoStories"
        description="Made with your lenses no stories."
        defaultMessage="No Spotlight stories found for your Lenses"
    />
);
MadeWithYourLensesNoStories.displayName = "MadeWithYourLensesNoStories";

export const MadeWithYourLensesError = (): ReactElement => (
    <FormattedMessage
        id="apps.home.components.madeWithYourLensesError"
        description="Made with your lenses error."
        defaultMessage="Unable to load Spotlight stories"
    />
);
MadeWithYourLensesError.displayName = "MadeWithYourLensesError";

export const MadeWithYourLensesVideoUnavailable = (): ReactElement => (
    <FormattedMessage
        id="apps.home.components.madeWithYourLensesVideoUnavailable"
        description="Made with your lenses video unavailable."
        defaultMessage="Video unavailable"
    />
);
MadeWithYourLensesVideoUnavailable.displayName = "MadeWithYourLensesVideoUnavailable";

export const NoTrendingItems = (): ReactElement => (
    <FormattedMessage
        id="apps.home.components.noTrendingItems"
        description="No trending items."
        defaultMessage="No trending items found"
    />
);
NoTrendingItems.displayName = "NoTrendingItems";

export const TableHeaderTrend = (): ReactElement => (
    <FormattedMessage
        id="apps.home.components.tableHeaderTrend"
        description="Table header trend."
        defaultMessage="Topic"
    />
);
TableHeaderTrend.displayName = "TableHeaderTrend";

export const NoDataForTimeRange = (): ReactElement => (
    <FormattedMessage
        id="apps.home.components.noDataForTimeRange"
        description="No data for time range."
        defaultMessage="No data for the selected time range"
    />
);
NoDataForTimeRange.displayName = "NoDataForTimeRange";

export const SeeAll = (): ReactElement => (
    <FormattedMessage id="apps.home.components.seeAll" description="See all." defaultMessage="See All" />
);
SeeAll.displayName = "SeeAll";

export const MonetizationBannerTitle = (): ReactElement => (
    <FormattedMessage
        id="apps.home.components.monetizationBannerTitle"
        description="Monetization banner title."
        defaultMessage="Payouts now live in Monetization"
    />
);
MonetizationBannerTitle.displayName = "MonetizationBannerTitle";

export const MonetizationBannerSubtitle = (): ReactElement => (
    <FormattedMessage
        id="apps.home.components.monetizationBannerSubtitle"
        description="Monetization banner subtitle."
        defaultMessage="Lens+ payouts are monthly and separate from the engagement metrics below. Track your payout drivers, cycle, and history in one place."
    />
);
MonetizationBannerSubtitle.displayName = "MonetizationBannerSubtitle";

export const MonetizationBannerCta = (): ReactElement => (
    <FormattedMessage
        id="apps.home.components.monetizationBannerCta"
        description="Monetization banner cta."
        defaultMessage="Go to Monetization"
    />
);
MonetizationBannerCta.displayName = "MonetizationBannerCta";

export const messages = defineMessages({
    madeWithYourLensesViewOnSpotlight: {
        id: "apps.home.components.madeWithYourLensesViewOnSpotlight",
        description: "Made with your lenses view on spotlight.",
        defaultMessage: "View on Spotlight",
    },
    leaderboardBannerDismiss: {
        id: "apps.home.components.leaderboardBannerDismiss",
        description: "Leaderboard banner dismiss.",
        defaultMessage: "Dismiss",
    },
});
